* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.signet-pdf-viewer {
  border: 1px solid #0000001f;
  border-radius: 4px;
  background-color: #fff;
  display: block;

  .pdf-header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #0000001f;
    padding: 8px 24px;

    p {
      color: var(--primary-main);
      font-size: 14px;
    }

    .icon {
      color: var(--primary-main);
      line-height: 0 !important;
      margin-left: 6px;
      cursor: pointer;
    }
  }

  .pdf-body {
    display: flex;
    justify-content: center;

    img {
      object-fit: contain;
      width: 100%;
    }
  }

  &.success {
    border: 1px solid #409565;
  }

  &.warning {
    border: 1px solid #ffa726;
  }
}
